export type CourseAssessment = {
  id: string;
  courseId: string;
  assessmentId: string;
};
